import styled from "styled-components";

const ErrorMsg = styled.div`
  color: red;
`;

export default ErrorMsg;
